import base from "../baseurl";
import token from "../getTk";

const Create = async (Uuid) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const details = await api.get("election/show/" + Uuid).json();
  return details;
};

export default Create;
